const $ = require("jquery");
window.$ = $;
window.jQuery = $;

require('./modules/_spMenu')
require('./modules/_toTop')
require('./modules/_smoothScrool')
require('./modules/_popup')
require('./modules/_lazyload.js')
